import {
  Button,
  Chip,
  Dialog,
  DialogBody,
  DialogFooter,
  DialogHeader,
  Input,
  Switch,
  Textarea,
  Typography
} from "@material-tailwind/react";
import Dict from "../../helper/dict";
import React, {useContext, useEffect, useState} from "react";
import "../../style/datePicker.css"
import SelectInput from "../system/select";
import {submitAgentServiceDocumentation, updateAgentServiceDocumentation} from "../../services/service/service";
import {getBranchDocuments} from "../../services/branch_document/branch_document";
import {ServiceContext} from "./service_context";
import FileCell from "../system/fileViewer";

export function AgentServiceDocumentationForm() {

    const {
        service,
        document,
        modalOpen,
        setModalOpen,
        setLastDataRefresh,
        setStep
    } = useContext(ServiceContext);

    const handleOpen = () => setModalOpen(!modalOpen);


    const [branchDocumentId, setBranchDocumentId] = useState(null)

    const [title, setTitle] = useState(document?.title ?? "")
    const [description, setDescription] = useState(document?.description ?? "")
    const [status, setStatus] = useState("")
    const [disable, setDisable] = useState(service.status === "finish")

    useEffect(() => {
        setTitle(document?.title ?? "")
        setDescription(document?.description ?? "")
        setStatus(document?.status ?? "")
    }, [Document]);

    const save = async () => {
        const data = {
            service_id: service.id,
            title: title,
            description: description,
            status: status,
        };
        let result;

        if (!document) {
            result = await submitAgentServiceDocumentation(data);
        } else {
            data.id = document.id
            result = await updateAgentServiceDocumentation(data)
        }

        if (result.status === 201 || result.status === 202) {
            setLastDataRefresh(Date.now())
            setStep("check")
        }
    };

    useEffect(() => {
        if (status === "upload") {
            setStatus("rejected")
        }
    }, [status]);

    return (
        <>
            <Dialog open={modalOpen} handler={handleOpen}
                    animate={{mount: {scale: 1, y: 0}, unmount: {scale: 0.9, y: -100}}}>
                <DialogHeader className="border-b">
                    {document &&
                        <Typography>
                            {service.person_name + " " + service.person_family + " - " + service.field_title + " " + service.branch_title + " ( " + title + " )"}
                        </Typography>
                    }
                    {!document &&
                        <Typography>ثبت مدرک جدید</Typography>
                    }
                </DialogHeader>
                <DialogBody className="flex flex-col gap-4 overflow-y-scroll">

                    {!document &&
                        <div className="mb-4">
                            <SelectInput
                                label={Dict("branch_document_recommended")}
                                defaultValue={branchDocumentId}
                                autoLoadService={getBranchDocuments}
                                autoLoadRender={({title, description}) => {
                                    setTitle(title)
                                    setDescription(description)
                                    return title + " - " + description
                                }}
                                onChange={setBranchDocumentId}
                            />
                        </div>
                    }

                    <div className="mb-4">
                        <Input variant="standard"
                               value={title}
                               label={Dict('title')}
                               placeholder={Dict('title')}
                               onChange={(e) => {
                                   setTitle(e.target.value)
                               }}
                        />
                    </div>

                    <div className="mb-4">
                        <Textarea variant="standard"
                                  value={description}
                                  label={Dict('description')}
                                  placeholder={Dict('description')}
                                  onChange={(e) => {
                                      setDescription(e.target.value)
                                  }}
                        />
                    </div>

                    {document && document.file &&
                        <div className="mb-4">
                            <FileCell
                                label={Dict('upload_file')}
                                fileCode={document.file}
                            />
                        </div>
                    }
                    {status && status === "new" &&
                        <div className="flex flex-row">
                            <Typography color="blue-gray" className="font-medium ml-2">
                                وضعیت مدرک:
                            </Typography>
                            <Chip className="textRight" variant="ghost"
                                  value={Dict(status)}
                                  color={status === "accepted" ? "teal" : status === "rejected" ? "red" : status === "new" ? "cyan" : status === "upload" ? "purple" : "red"}/>
                        </div>
                    }

                    {status && status !== "new" &&
                        <div className="">
                            <Switch
                                label={
                                    <Typography color="blue-gray" className="font-medium">
                                        اگر فایل های ارسالی مورد تائید می باشد دکمه را فعال کنید
                                    </Typography>
                                }
                                checked={status === "accepted" ? true : false}
                                onChange={(e) => {
                                    if (e.target.checked) {
                                        setStatus("accepted")
                                    } else {
                                        setStatus("rejected")
                                    }
                                }}
                                labelProps={{className: "mx-4"}}
                            />
                        </div>
                    }

                </DialogBody>
                <DialogFooter className="space-x-2">
                    {!disable &&
                        <Button variant="gradient" color="gray" onClick={save} className="ml-1">
                            <span>ذخیره</span>
                        </Button>
                    }
                    <Button variant="text" color="gray" onClick={() => {
                        // handleOpen();
                        setStep("check")
                    }}>
                        <span>انصراف</span>
                    </Button>
                </DialogFooter>
            </Dialog>
        </>
    );
}